export const downloadWithIframe = (url) => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none' // 防止影响页面
  iframe.style.height = 0 // 防止影响页面
  iframe.src = url
  document.body.appendChild(iframe) // 这一行必须，iframe挂在到dom树上才会发请求
  // 5分钟之后删除
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 5 * 60 * 1000)
}
